import React from "react";
import { Helmet } from "react-helmet";
const AnimationportfolioHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        2D/3D Animation Portfolio | Digious Solutions
      </title>
      <meta
        name="description"
        content="See Digious Solutions’ animation portfolio highlighting motion graphics, 2D/3D animations, and visual storytelling that bring ideas to life."
      />
    </Helmet>
  );
};

export default AnimationportfolioHelmet;
